var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "coverViewWrapper" }, [
    _c("div", { staticClass: "imageWrap" }, [
      _vm.error
        ? _c("div", { staticClass: "retryWrap" }, [
            _c(
              "i",
              {
                staticClass: "material-icons statusIcon",
                on: { click: _vm.clickImage },
              },
              [_vm._v("\n\t\t\t\twarning\n\t\t\t")]
            ),
            _vm._v(" "),
            _vm.showRetry && _vm.fetchAttempts === 0
              ? _c(
                  "span",
                  {
                    staticClass: "retry",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.retry.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("\n\t\t\t\t\trefresh\n\t\t\t\t"),
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v("Retry")]),
                  ]
                )
              : _vm._e(),
          ])
        : _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loaded,
                expression: "loaded",
              },
            ],
            attrs: { src: _vm.imageUrl },
            on: {
              error: _vm.onLoadError,
              load: _vm.onLoad,
              click: _vm.clickImage,
            },
          }),
      _vm._v(" "),
      !_vm.loaded && _vm.showPlaceHolder
        ? _c("img", {
            staticClass: "placeholderImg",
            attrs: { src: _vm.placeholderImg },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.error && !_vm.loaded
        ? _c(
            "svg",
            {
              staticClass: "loaderWrap",
              attrs: { viewBox: "0 0 32 32", width: "64", height: "64" },
            },
            [
              _c("circle", {
                attrs: {
                  id: "spinner",
                  cx: "16",
                  cy: "16",
                  r: "14",
                  fill: "none",
                },
              }),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }